import React, { Component } from 'react';
import { Table, Row, Col, InputNumber, Button, DatePicker, message, Spin, Input, Tooltip } from 'antd';
import moment from 'moment';
import { data7_1_2 } from './data';
import imgSave from "../../saveImg";
import Auth from "../../Auth";
import Compared from "../../Compared";
import { calculation, sum, numConvert } from '@/method';
import TableText from "../../TableText"
import _ from 'lodash';
import Chart from './components/Chart'
import { getChart } from './compute'

const { MonthPicker } = DatePicker;
const { TextArea } = Input;

class index extends Component {
    constructor(props) {
        super(props);
        this.state = {
            date: moment().subtract(1, 'month').format('YYYY-MM'),
            data: [],
            note: { note: "" },
            loading: true,
            loadingSave: false,
            print: false,
            last: [],
            data7_1: []
        }
    }


    componentDidMount() {
        this.getDateData(this.state.date);
    }



    computeNum = (data, last) => {
        const date = this.state.date;
        const isJan = moment(date).format('M') == 1;
        const totalName = ['thisy_employee_num', 'thisy_average_payroll', 'lasty_employee_num', 'lasty_average_payroll', 'year_thisy_employee_num', 'year_thisy_average_payroll', 'year_lasty_employee_num', 'year_lasty_average_payroll'];
        const isOpenLastFill = moment(date).isBefore(moment("2022-02"));
        // 填充年累计
        if (!isOpenLastFill) {
            for (let i = 0; i < data.length; i++) {
                data[i].year_thisy_employee_num = sum([data[i].thisy_employee_num, _.get(last, `${i}.year_thisy_employee_num`, 0)]);
                data[i].year_thisy_average_payroll = sum([data[i].thisy_average_payroll, _.get(last, `${i}.year_thisy_average_payroll`, 0)]);
                data[i].year_lasty_employee_num = sum([data[i].lasty_employee_num, _.get(last, `${i}.year_lasty_employee_num`, 0)]);
                data[i].year_lasty_average_payroll = sum([data[i].lasty_average_payroll, _.get(last, `${i}.year_lasty_average_payroll`, 0)]);
            }
        }


        for (let i = 0; i < totalName.length; i++) {
            data[7][totalName[i]] = data.reduce((a, b, index) => {
                if (index < 7) {
                    if (index > 2) {
                        a -= numConvert(b[totalName[i]]);
                    } else {
                        a += numConvert(b[totalName[i]]);
                    }

                    return a
                }
                return a
            }, 0);
            data[7][totalName[i]] = data[7][totalName[i]].toFixed(2);
        };

        for (let i = 0; i < data.length; i++) {
            if (i <= 7) {
                data[i].thisy_payroll_cost = (numConvert(data[i].thisy_employee_num) + (numConvert(data[i].thisy_average_payroll))).toFixed(2);
                data[i].lasty_payroll_cost = (numConvert(data[i].lasty_employee_num) + (numConvert(data[i].lasty_average_payroll))).toFixed(2);
                data[i].variance_emplyee_num = (numConvert(data[i].thisy_employee_num) - numConvert(data[i].lasty_employee_num)).toFixed(2);
                data[i].ven_percent = (numConvert(data[i].lasty_employee_num) == 0 ? 0 : (numConvert(data[i].variance_emplyee_num) / numConvert(data[i].lasty_employee_num))).toFixed(4);
                data[i].variance_average_payroll = (numConvert(data[i].thisy_average_payroll) - numConvert(data[i].lasty_average_payroll)).toFixed(2);
                data[i].vap_percent = (numConvert(data[i].lasty_average_payroll) == 0 ? 0 : (numConvert(data[i].variance_average_payroll) / numConvert(data[i].lasty_average_payroll))).toFixed(4);
                data[i].variance_payroll = (numConvert(data[i].thisy_payroll_cost) - numConvert(data[i].lasty_payroll_cost)).toFixed(2);
                data[i].vp_percent = (numConvert(data[i].lasty_payroll_cost) == 0 ? 0 : (numConvert(data[i].variance_payroll) / numConvert(data[i].lasty_payroll_cost))).toFixed(4);

                data[i].year_thisy_payroll_cost = (numConvert(data[i].year_thisy_employee_num) + (numConvert(data[i].year_thisy_average_payroll))).toFixed(2);
                data[i].year_lasty_payroll_cost = (numConvert(data[i].year_lasty_employee_num) + (numConvert(data[i].year_lasty_average_payroll))).toFixed(2);
                data[i].year_variance_emplyee_num = (numConvert(data[i].year_thisy_employee_num) - numConvert(data[i].year_lasty_employee_num)).toFixed(2);
                data[i].year_ven_percent = (numConvert(data[i].year_lasty_employee_num) == 0 ? 0 : (numConvert(data[i].year_variance_emplyee_num) / numConvert(data[i].year_lasty_employee_num))).toFixed(4);
                data[i].year_variance_average_payroll = (numConvert(data[i].year_thisy_average_payroll) - numConvert(data[i].year_lasty_average_payroll)).toFixed(2);
                data[i].year_vap_percent = (numConvert(data[i].year_lasty_average_payroll) == 0 ? 0 : (numConvert(data[i].year_variance_average_payroll) / numConvert(data[i].year_lasty_average_payroll))).toFixed(4);
                data[i].year_variance_payroll = (numConvert(data[i].year_thisy_payroll_cost) - numConvert(data[i].year_lasty_payroll_cost)).toFixed(2);
            }
        }

        const footName = ['thisy_employee_num', 'thisy_average_payroll', 'thisy_payroll_cost', 'lasty_employee_num', 'lasty_average_payroll', 'lasty_payroll_cost', 'year_thisy_employee_num', 'year_thisy_average_payroll', 'year_thisy_payroll_cost', 'year_lasty_employee_num', 'year_lasty_average_payroll', 'year_lasty_payroll_cost'];

        for (let i = 0; i < footName.length; i++) {
            data[8][footName[i]] = (numConvert(data[3][footName[i]]) + numConvert(data[4][footName[i]]) + numConvert(data[5][footName[i]]) + numConvert(data[6][footName[i]])).toFixed(2);
        };

        // 流动数
        data[8].variance_emplyee_num = (numConvert(data[8].thisy_employee_num) - numConvert(data[8].lasty_employee_num)).toFixed(2);
        data[8].ven_percent = (numConvert(data[8].variance_emplyee_num) == 0 ? 0 : (numConvert(data[8].lasty_employee_num) / numConvert(data[8].variance_emplyee_num))).toFixed(4);
        data[8].variance_average_payroll = (numConvert(data[8].thisy_average_payroll) - numConvert(data[8].lasty_average_payroll)).toFixed(2);
        data[8].vap_percent = (numConvert(data[8].lasty_average_payroll) == 0 ? 0 : (numConvert(data[8].variance_average_payroll) / numConvert(data[8].lasty_average_payroll))).toFixed(4);
        data[8].variance_payroll = (numConvert(data[8].thisy_payroll_cost) - numConvert(data[8].lasty_payroll_cost)).toFixed(2);
        data[8].vp_percent = (numConvert(data[8].lasty_payroll_cost) == 0 ? 0 : (numConvert(data[8].variance_payroll) / numConvert(data[8].lasty_payroll_cost))).toFixed(4);

        data[8].year_variance_emplyee_num = (numConvert(data[8].year_thisy_employee_num) - numConvert(data[8].year_lasty_employee_num)).toFixed(2);
        data[8].vp_percent = (numConvert(data[8].year_lasty_employee_num) == 0 ? 0 : (numConvert(data[8].year_variance_emplyee_num) / numConvert(data[8].year_lasty_employee_num))).toFixed(4);
        data[8].year_variance_average_payroll = (numConvert(data[8].year_thisy_average_payroll) - numConvert(data[8].year_lasty_average_payroll)).toFixed(2);
        data[8].vp_percent = (numConvert(data[8].year_lasty_average_payroll) == 0 ? 0 : (numConvert(data[8].year_variance_average_payroll) / numConvert(data[8].year_lasty_average_payroll))).toFixed(4);
        data[8].year_variance_emplyee_num = (numConvert(data[8].year_thisy_payroll_cost) - numConvert(data[8].year_lasty_payroll_cost)).toFixed(2);

        for (let i = 0; i < footName.length; i++) {
            if (!footName[i].includes('year')) data[9][footName[i]] = calculation(numConvert(data[8][footName[i]]),
                isJan ? numConvert(data[7][footName[i]]) : ((numConvert(data[0][footName[i]]) + numConvert(data[7][footName[i]])) / 2),
                2
            )

            if (footName[i].includes('year')) data[9][footName[i]] = calculation(numConvert(data[8][footName[i]]),
                isJan ? numConvert(data[7][footName[i]]) : (data[7][footName[i]] / moment(date).format('M')),
                2
            )
        };
        // 流失率
        data[9].variance_emplyee_num = (numConvert(data[9].thisy_employee_num) - numConvert(data[9].lasty_employee_num)).toFixed(2);
        data[9].variance_average_payroll = (numConvert(data[9].thisy_average_payroll) - numConvert(data[9].lasty_average_payroll)).toFixed(2);
        data[9].year_variance_emplyee_num = (numConvert(data[9].year_thisy_employee_num) - numConvert(data[9].year_lasty_employee_num)).toFixed(2);
        data[9].year_variance_average_payroll = (numConvert(data[9].year_thisy_average_payroll) - numConvert(data[9].year_lasty_average_payroll)).toFixed(2);



        this.setState({
            data
        });

    }
    onChange = (name, value, i) => {
        let data = this.state.data;
        data[i][name] = value;
        this.computeNum(data, this.state.last);
    }

    getDateData = (date) => {
        let data = JSON.parse(JSON.stringify(data7_1_2));
        fetch(`/t7_2_info?year=${moment(date).format('YYYY')}&month=${moment(date).format('M')}`, { credentials: 'include' }).then(x => x.json()).then(x => {
            if (x.data.data && x.data.data.length > 0) {
                data = x.data.data;
            }
            data = data.map((_x, i) => ({
                ..._x,
                lasty_employee_num: ~~_.get(x, `data.last.[${i}].thisy_employee_num`, 0),
                lasty_average_payroll: ~~_.get(x, `data.last.[${i}].thisy_average_payroll`, 0),
            }))

            this.computeNum(data, x.data.lastMonth);
            this.setState({ loading: false, last: x.data.lastMonth || [], data7_1: x.data.data7_1, note: { ...x.data.note } });
            getChart(moment(date).format('YYYY'));
        }).catch(err => {
            console.error(err);
            this.setState({ loading: false });
        })
    }


    onSave = () => {
        this.setState({ loadingSave: true });
        let date = this.state.date;
        if (!date) {
            message.error('请选择年份月份');
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            return
        }
        let year = moment(date).format("YYYY");
        let month = moment(date).format("M");
        let data = this.state.data.map(x => ({ ...x, year, month }));
        let dataFrom = new FormData();
        dataFrom.append('data', JSON.stringify(data));
        let headres = {
            method: 'post',
            credentials: 'include',
            headers: {},
            body: dataFrom
        }
        if (this.state.note) {
            this.onSaveNote([{ ...this.state.note, month, year, }])
        }
        fetch('/add_7_2_1', headres).then(x => x.json()).then(x => {
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            if (x.status == 1) {
                message.success(x.msg);
                if (!data[0].id) {
                    this.getDateData(this.state.date);
                }
                return
            }
            message.error(x.msg);
        }).catch(err => {
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            console.error(err);
            message.error('保存失败' + JSON.stringify(err));
        })
    }

    onSaveNote = (data) => {
        let dataFrom = new FormData();
        dataFrom.append('data', JSON.stringify(data));
        let headres = {
            method: 'post',
            credentials: 'include',
            headers: {},
            body: dataFrom
        }
        fetch('/add_7_2_2', headres).then(x => x.json()).then(x => {
            if (x.status == 1) {
                // message.success(x.msg);
                return
            }
            message.error('备注保存失败：' + x.msg);
        }).catch(err => {
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            console.error(err);
        })
    }

    downloadSG = () => {

        this.setState({ print: true, loading: true }, () => {
            imgSave('table7_2', 1.5, '7.20', this.state.date).then(x => {
                if (x.status == 1) {
                    message.info('添加成功！');
                } else {
                    message.error('添加失败' + x.msg);
                }

                this.setState({
                    print: false,
                    loading: false
                });
            }).catch(err => {
                console.error(err);
                this.setState({
                    print: false,
                    loading: false
                });
            })

        });

    }

    render() {
        const { data, data7_1, date } = this.state;
        const isOpenLastFill = moment(date).isBefore(moment("2022-02"));
        const columns = [{
            title: 'Key Index 关键数据',
            dataIndex: 'name',
            key: 'name',
            align: "center",
            fixed: "left",
            width: 300,
            render: (text, record, index) => {
                return (
                    <div className={`table-padding ${index == 7 ? 'table-color-footer' : ''}`} style={{ textAlign: "left" }}>
                        {text}
                    </div>
                )
            }
        }, {
            title: 'Current Month 本年当月',
            align: "center",
            width: 1800,
            children: [{
                align: "center",
                title: 'MTD Actual - This Year 本年当月实际数',
                width: 450,
                children: [{
                    title: <div>Full Time 全职</div>,
                    dataIndex: 'thisy_employee_num',
                    key: 'thisy_employee_num',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        const title = ['Current Month 本年当月', 'MTD Actual - This Year 本年当月实际数', 'Full Time 全职'];
                        if (index == 9) return <TableText data={{
                            text, index, type: 'percent', name: "thisy_employee_num", onChange: this.onChange, compared: {
                                title, record, sqlName: "_7_2_1"
                            }
                        }} />;

                        if (index != 7 && index != 8 && index != 9) {
                            return (
                                <Compared data={{
                                    index, key: 'thisy_employee_num', title, sqlName: "_7_2_1", name: record.name, type: 'number'
                                }} >
                                    <div className="table-padding table-color-number">
                                        <InputNumber
                                            formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                            parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                            precision={2}
                                            className="table_numInput"
                                            defaultValue={text}
                                            onBlur={(e) => {
                                                let value = Number(e.target.value.replace(/,/g, '') || '0');
                                                value = Number(value.toFixed(2));
                                                this.onChange('thisy_employee_num', value, index)
                                            }}

                                        />
                                    </div>
                                </Compared >
                            )
                        } else {
                            return (
                                <Compared data={{ index, key: 'thisy_employee_num', title, sqlName: "_7_2_1", name: record.name, type: 'number' }}>
                                    <Tooltip title={index == 7 && ~~text != ~~(_.get(data7_1, '[11].thisy_employee_num') - _.get(data7_1, '[10].thisy_employee_num')) ? '该项设置ES 7.1的数据不一致，请检查' : ''}>
                                        <div className={`table-padding ${index == 7 ? 'table-color-footer' : ''} ${index == 7 && ~~text != ~~(_.get(data7_1, '[11].thisy_employee_num') - _.get(data7_1, '[10].thisy_employee_num')) ? 'yellowWaring' : ''}`} >
                                            {Number(text) < 0 ? <span style={{ color: "red" }}>({Math.abs(text)})</span> : text.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}{index == 9 ? '%' : ''}
                                        </div>
                                    </Tooltip>

                                </Compared>
                            )
                        }
                    }
                }, {
                    title: <div>Trainee 实习生</div>,
                    dataIndex: 'thisy_average_payroll',
                    key: 'thisy_average_payroll',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        const title = ['Current Month 本年当月', 'MTD Actual - This Year 本年当月实际数', 'Trainee 实习生'];
                        if (index == 9) {
                            return (
                                <div className={`table-padding ${index == 7 ? 'table-color-footer' : ''}`} style={{ textAlign: "left" }}>
                                    -
                                </div>
                            )
                        }
                        if (index != 7 && index != 8 && index != 9) {
                            return (
                                <Compared data={{ index, key: 'thisy_average_payroll', title, sqlName: "_7_2_1", name: record.name, type: 'number' }}>
                                    <div className="table-padding table-color-number">
                                        <InputNumber
                                            formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                            parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                            precision={2}
                                            className="table_numInput"
                                            defaultValue={text}
                                            onBlur={(e) => {
                                                let value = Number(e.target.value.replace(/,/g, '') || '0');
                                                value = Number(value.toFixed(2));
                                                this.onChange('thisy_average_payroll', value, index)
                                            }}

                                        />
                                    </div>
                                </Compared>
                            )
                        } else {
                            return (
                                <Compared data={{ index, key: 'thisy_average_payroll', title, sqlName: "_7_2_1", name: record.name, type: 'number' }}>
                                    <Tooltip title={index == 7 && ~~text != ~~_.get(data7_1, '[10].thisy_employee_num') ? '该项设置ES 7.1的数据不一致，请检查' : ''}>
                                        <div className={`table-padding ${index == 7 ? 'table-color-footer' : ''} ${index == 7 && ~~text != ~~_.get(data7_1, '[10].thisy_employee_num') ? 'yellowWaring' : ''}`} >
                                            {Number(text) < 0 ? <span style={{ color: "red" }}>({Math.abs(text)})</span> : text.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}{index == 9 ? '%' : ''}
                                        </div>
                                    </Tooltip>
                                </Compared>
                            )
                        }
                    }
                }, {
                    title: <div>FTE 全体员工</div>,
                    dataIndex: 'thisy_payroll_cost',
                    key: 'thisy_payroll_cost',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        const title = ['Current Month 本年当月', 'MTD Actual - This Year 本年当月实际数', 'FTE 全体员工'];
                        if (index == 9) {
                            return (
                                <div className={`table-padding ${index == 7 ? 'table-color-footer' : ''}`} style={{ textAlign: "left" }}>
                                    -
                                </div>
                            )
                        }
                        return (
                            <Compared data={{ index, key: 'thisy_payroll_cost', title, sqlName: "_7_2_1", name: record.name, type: 'number' }}>
                                <Tooltip title={index == 7 && ~~text != ~~_.get(data7_1, '[11].thisy_employee_num') ? '该项设置ES 7.1的数据不一致，请检查' : ''}>
                                    <div className={`table-padding ${index == 7 ? 'table-color-footer' : ''} ${index == 7 && ~~text != ~~_.get(data7_1, '[11].thisy_employee_num') ? 'yellowWaring' : ''}`} >
                                        {Number(text) < 0 ? <span style={{ color: "red" }}>({Math.abs(text)})</span> : text.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}{index == 9 ? '%' : ''}
                                    </div>
                                </Tooltip>
                            </Compared>
                        )
                    }
                }]
            }, {
                align: "center",
                title: 'MTD Actual - Last Year 去年当月实际数',
                width: 450,
                children: [{
                    title: <div>Full Time 全职</div>,
                    dataIndex: 'lasty_employee_num',
                    key: 'lasty_employee_num',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        const title = ['Current Month 本年当月', 'MTD Actual - Last Year 去年当月实际数', 'Full Time 全职'];
                        if (index == 9) return <TableText data={{
                            text, index, type: 'percent', name: "lasty_employee_num", onChange: this.onChange, compared: {
                                title, record, sqlName: "_7_2_1"
                            }
                        }} />;
                        return (
                            <Compared data={{ index, key: 'lasty_employee_num', title, sqlName: "_7_2_1", name: record.name, type: 'number' }}>
                                <div className={`table-padding ${index == 7 ? 'table-color-footer' : ''}`} >
                                    {Number(text) < 0 ? <span style={{ color: "red" }}>({Math.abs(text)})</span> : text.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}{index == 9 ? '%' : ''}
                                </div>
                            </Compared>
                        )

                    }
                }, {
                    title: <div>Trainee 实习生</div>,
                    dataIndex: 'lasty_average_payroll',
                    key: 'lasty_average_payroll',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        const title = ['Current Month 本年当月', 'MTD Actual - Last Year 去年当月实际数', 'Trainee 实习生'];
                        if (index == 9) {
                            return (
                                <div className={`table-padding ${index == 7 ? 'table-color-footer' : ''}`} style={{ textAlign: "left" }}>
                                    -
                                </div>
                            )
                        }
                        return (
                            <Compared data={{ index, key: 'lasty_average_payroll', title, sqlName: "_7_2_1", name: record.name, type: 'number' }}>
                                <div className={`table-padding ${index == 7 ? 'table-color-footer' : ''}`} >
                                    {Number(text) < 0 ? <span style={{ color: "red" }}>({Math.abs(text)})</span> : text.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}{index == 9 ? '%' : ''}
                                </div>
                            </Compared>
                        )
                    }
                }, {
                    title: <div>FTE 全体员工</div>,
                    dataIndex: 'lasty_payroll_cost',
                    key: 'lasty_payroll_cost',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        const title = ['Current Month 本年当月', 'MTD Actual - Last Year 去年当月实际数', 'FTE 全体员工'];
                        if (index == 9) {
                            return (
                                <div className={`table-padding ${index == 7 ? 'table-color-footer' : ''}`} style={{ textAlign: "left" }}>
                                    -
                                </div>
                            )
                        }
                        return (
                            <Compared data={{ index, key: 'lasty_payroll_cost', title, sqlName: "_7_2_1", name: record.name, type: 'number' }}>
                                <div className={`table-padding ${index == 7 ? 'table-color-footer' : ''}`} >
                                    {Number(text) < 0 ? <span style={{ color: "red" }}>({Math.abs(text)})</span> : text.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                </div>
                            </Compared>
                        )
                    }
                }]
            }, {
                align: "center",
                title: 'Current Month Variance - This Year vs. Last Year 当月差异 - 今年对比去年',
                width: 900,
                children: [{
                    title: <div>Full Time 全职</div>,
                    dataIndex: 'variance_emplyee_num',
                    key: 'variance_emplyee_num',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        const title = ['Current Month 本年当月', 'Current Month Variance - This Year vs. Last Year 当月差异 - 今年对比去年', 'Full Time 全职'];
                        if (index == 9) return <TableText data={{
                            text, index, type: 'percent', name: "variance_emplyee_num", onChange: this.onChange, compared: {
                                title, record, sqlName: "_7_2_1"
                            }
                        }} />;
                        return (
                            <Compared data={{ index, key: 'variance_emplyee_num', title, sqlName: "_7_2_1", name: record.name, type: 'number' }}>
                                <div className={`table-padding  ${index == 7 ? 'table-color-footer' : ''}`} >
                                    {Number(text) < 0 ? <span style={{ color: "red" }}>({Math.abs(text)})</span> : text.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}{index == 9 ? '%' : ''}
                                </div>
                            </Compared>
                        )
                    }
                }, {
                    title: '% 百分比',
                    dataIndex: 'ven_percent',
                    key: 'ven_percent',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        const title = ['Current Month 本年当月', 'Current Month Variance - This Year vs. Last Year 当月差异 - 今年对比去年', '% 百分比'];
                        if (index == 9) return <TableText data={{
                            text, index, type: 'percent', name: "ven_percent", onChange: this.onChange, compared: {
                                title, record, sqlName: "_7_2_1"
                            }
                        }} />;
                        return (
                            <Compared data={{ index, key: 'ven_percent', title, sqlName: "_7_2_1", name: record.name, type: 'percent' }}>
                                <div className={`table-padding ${index == 7 ? 'table-color-footer' : ''}`} >
                                    {Number(text) < 0 ? <span style={{ color: "red" }}>({(Math.abs(text) * 100).toFixed(1) + '%'})</span> : (text * 100).toFixed(1) + '%'}
                                </div>
                            </Compared>
                        )
                    }
                }, {
                    title: <div>Trainee 实习生</div>,
                    dataIndex: 'variance_average_payroll',
                    key: 'variance_average_payroll',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        const title = ['Current Month 本年当月', 'Current Month Variance - This Year vs. Last Year 当月差异 - 今年对比去年', 'Trainee 实习生'];
                        if (index == 9) {
                            return (
                                <div className={`table-padding ${index == 7 ? 'table-color-footer' : ''}`} style={{ textAlign: "left" }}>
                                    -
                                </div>
                            )
                        }
                        return (
                            <Compared data={{ index, key: 'variance_average_payroll', title, sqlName: "_7_2_1", name: record.name, type: 'number' }}>
                                <div className={`table-padding ${index == 7 ? 'table-color-footer' : ''}`} >
                                    {Number(text) < 0 ? <span style={{ color: "red" }}>({Math.abs(text)})</span> : text.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}{index == 9 ? '%' : ''}
                                </div>
                            </Compared>
                        )
                    }
                }, {
                    title: '% 百分比',
                    dataIndex: 'vap_percent',
                    align: "center",
                    key: 'vap_percent',
                    width: 150,
                    render: (text, record, index) => {
                        const title = ['Current Month 本年当月', 'Current Month Variance - This Year vs. Last Year 当月差异 - 今年对比去年', '% 百分比'];
                        return (
                            <Compared data={{ index, key: 'vap_percent', title, sqlName: "_7_2_1", name: record.name, type: 'percent' }}>
                                <div className={`table-padding ${index == 7 ? 'table-color-footer' : ''}`} >
                                    {Number(text) < 0 ? <span style={{ color: "red" }}>({(Math.abs(text) * 100).toFixed(1) + '%'})</span> : (text * 100).toFixed(1) + '%'}
                                </div>
                            </Compared>
                        )
                    }
                }, {
                    title: <div>FTE 全体员工</div>,
                    dataIndex: 'variance_payroll',
                    key: 'variance_payroll',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        const title = ['Current Month 本年当月', 'Current Month Variance - This Year vs. Last Year 当月差异 - 今年对比去年', 'FTE 全体员工'];
                        if (index == 9) {
                            return (
                                <div className={`table-padding ${index == 7 ? 'table-color-footer' : ''}`} style={{ textAlign: "left" }}>
                                    -
                                </div>
                            )
                        }
                        return (
                            <Compared data={{ index, key: 'variance_payroll', title, sqlName: "_7_2_1", name: record.name, type: 'number' }}>
                                <div className={`table-padding ${index == 7 ? 'table-color-footer' : ''}`} >
                                    {Number(text) < 0 ? <span style={{ color: "red" }}>({Math.abs(text)})</span> : text.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                </div>
                            </Compared>
                        )
                    }
                }, {
                    title: '% 百分比',
                    dataIndex: 'vp_percent',
                    key: 'vp_percent',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        const title = ['Current Month 本年当月', 'Current Month Variance - This Year vs. Last Year 当月差异 - 今年对比去年', '% 百分比'];
                        return (
                            <Compared data={{ index, key: 'vp_percent', title, sqlName: "_7_2_1", name: record.name, type: 'percent' }}>
                                <div className={`table-padding  ${index == 7 ? 'table-color-footer' : ''}`} >
                                    {Number(text) < 0 ? <span style={{ color: "red" }}>({(Math.abs(text) * 100).toFixed(1) + '%'})</span> : (text * 100).toFixed(1) + '%'}
                                </div>
                            </Compared>
                        )
                    }
                }]
            },],
        }, {
            title: 'YTD 年累计',
            align: "center",
            width: 1650,
            children: [{
                align: "center",
                title: 'YTD Actual - This Year 年累计实际 - 今年',
                width: 450,
                children: [{
                    title: <div>Full Time 全职</div>,
                    dataIndex: 'year_thisy_employee_num',
                    key: 'year_thisy_employee_num',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        const title = ['YTD 年累计', 'YTD Actual - This Year 年累计实际 - 今年', 'Full Time 全职'];
                        if (index == 9) return <TableText data={{
                            text, index, type: 'percent', name: "year_thisy_employee_num", onChange: this.onChange, compared: {
                                title, record, sqlName: "_7_2_1"
                            }
                        }} />;
                        if (index != 7 && index != 8 && index != 9 && isOpenLastFill) {
                            return (
                                <Compared data={{ index, key: 'year_thisy_employee_num', title, sqlName: "_7_2_1", name: record.name, type: 'number' }}>
                                    <div className="table-padding table-color-number">
                                        <InputNumber
                                            formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                            parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                            precision={2}
                                            className="table_numInput"
                                            defaultValue={text}
                                            onBlur={(e) => {
                                                let value = Number(e.target.value.replace(/,/g, '') || '0');
                                                value = Number(value.toFixed(2));
                                                this.onChange('year_thisy_employee_num', value, index)
                                            }}
                                        />
                                    </div>
                                </Compared>
                            )
                        } else {
                            return (
                                <Compared data={{ index, key: 'year_thisy_employee_num', title, sqlName: "_7_2_1", name: record.name, type: 'number' }}>
                                    <Tooltip title={index == 7 && ~~text != (~~_.get(data7_1, '[11].year_thisy_employee_num') - ~~_.get(data7_1, '[10].year_thisy_employee_num')) ? '该项设置ES 7.1的数据不一致，请检查' : ''}>
                                        <div className={`table-padding ${index == 7 ? 'table-color-footer' : ''} ${index == 7 && ~~text != (~~_.get(data7_1, '[11].year_thisy_employee_num') - ~~_.get(data7_1, '[10].year_thisy_employee_num')) ? 'yellowWaring' : ''}`} >
                                            {Number(text) < 0 ? <span style={{ color: "red" }}>({Math.abs(text)})</span> : text.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}{index == 9 ? '%' : ''}
                                        </div>
                                    </Tooltip>
                                </Compared >
                            )
                        }

                    }
                }, {
                    title: <div>Trainee 实习生</div>,
                    dataIndex: 'year_thisy_average_payroll',
                    key: 'year_thisy_average_payroll',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        const title = ['YTD 年累计', 'YTD Actual - This Year 年累计实际 - 今年', 'Trainee 实习生'];
                        if (index == 9) {
                            return (
                                <div className={`table-padding ${index == 7 ? 'table-color-footer' : ''}`} style={{ textAlign: "left" }}>
                                    -
                                </div>
                            )
                        }
                        if (index != 7 && index != 8 && index != 9 && isOpenLastFill) {
                            return (
                                <Compared data={{ index, key: 'year_thisy_average_payroll', title, sqlName: "_7_2_1", name: record.name, type: 'number' }}>
                                    <div className="table-padding table-color-number">
                                        <InputNumber
                                            formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                            parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                            precision={2}
                                            className="table_numInput"
                                            defaultValue={text}
                                            onBlur={(e) => {
                                                let value = Number(e.target.value.replace(/,/g, '') || '0');
                                                value = Number(value.toFixed(2));
                                                this.onChange('year_thisy_average_payroll', value, index)
                                            }}
                                        />
                                    </div>
                                </Compared>
                            )
                        } else {
                            return (
                                <Compared data={{ index, key: 'year_thisy_average_payroll', title, sqlName: "_7_2_1", name: record.name, type: 'number' }}>
                                    <Tooltip title={index == 7 && ~~text != (~~_.get(data7_1, '[10].year_thisy_employee_num')) ? '该项设置ES 7.1的数据不一致，请检查' : ''}>
                                        <div className={`table-padding ${index == 7 ? 'table-color-footer' : ''} ${index == 7 && ~~text != (~~_.get(data7_1, '[10].year_thisy_employee_num')) ? 'yellowWaring' : ''}`} >
                                            {Number(text) < 0 ? <span style={{ color: "red" }}>({Math.abs(text)})</span> : text.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}{index == 9 ? '%' : ''}
                                        </div>
                                    </Tooltip>
                                </Compared >
                            )
                        }
                    }
                }, {
                    title: <div>FTE 全体员工</div>,
                    dataIndex: 'year_thisy_payroll_cost',
                    key: 'year_thisy_payroll_cost',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        const title = ['YTD 年累计', 'YTD Actual - This Year 年累计实际 - 今年', 'FTE 全体员工'];
                        if (index == 9) {
                            return (
                                <div className={`table-padding ${index == 7 ? 'table-color-footer' : ''}`} style={{ textAlign: "left" }}>
                                    -
                                </div>
                            )
                        }
                        return (
                            <Compared data={{ index, key: 'year_thisy_payroll_cost', title, sqlName: "_7_2_1", name: record.name, type: 'number' }}>
                                <Tooltip title={index == 7 && ~~text != (~~_.get(data7_1, '[11].year_thisy_employee_num')) ? '该项设置ES 7.1的数据不一致，请检查' : ''}>
                                    <div className={`table-padding ${index == 7 ? 'table-color-footer' : ''} ${index == 7 && ~~text != (~~_.get(data7_1, '[11].year_thisy_employee_num')) ? 'yellowWaring' : ''}`} >
                                        {Number(text) < 0 ? <span style={{ color: "red" }}>({Math.abs(text)})</span> : text.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}{index == 9 ? '%' : ''}
                                    </div>
                                </Tooltip>
                            </Compared >
                        )
                    }
                }]
            }, {
                align: "center",
                title: 'YTD Actual - Last Year 年累计实际 - 去年',
                width: 450,
                children: [{
                    title: <div>Full Time 全职</div>,
                    dataIndex: 'year_lasty_employee_num',
                    key: 'year_lasty_employee_num',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        const title = ['YTD 年累计', 'YTD Actual - Last Year 年累计实际 - 去年', 'Full Time 全职'];
                        if (index == 9) return <TableText data={{
                            text, index, type: 'percent', name: "year_lasty_employee_num", onChange: this.onChange, compared: {
                                title, record, sqlName: "_7_2_1"
                            }
                        }} />;
                        if (index != 7 && index != 8 && index != 9 && isOpenLastFill) {
                            return (
                                <Compared data={{ index, key: 'year_lasty_employee_num', title, sqlName: "_7_2_1", name: record.name, type: 'number' }}>
                                    <div className="table-padding table-color-number">
                                        <InputNumber
                                            formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                            parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                            precision={2}
                                            className="table_numInput"
                                            defaultValue={text}
                                            onBlur={(e) => {
                                                let value = Number(e.target.value.replace(/,/g, '') || '0');
                                                value = Number(value.toFixed(2));
                                                this.onChange('year_lasty_employee_num', value, index)
                                            }}
                                        />
                                    </div>
                                </Compared>
                            )
                        } else {
                            return (
                                <Compared data={{ index, key: 'year_lasty_employee_num', title, sqlName: "_7_2_1", name: record.name, type: 'number' }}>
                                    <div className={`table-padding ${index == 7 ? 'table-color-footer' : ''}`} >
                                        {Number(text) < 0 ? <span style={{ color: "red" }}>({Math.abs(text)})</span> : text.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}{index == 9 ? '%' : ''}
                                    </div>
                                </Compared>
                            )
                        }

                    }
                }, {
                    title: <div>Trainee 实习生</div>,
                    dataIndex: 'year_lasty_average_payroll',
                    key: 'year_lasty_average_payroll',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        const title = ['YTD 年累计', 'YTD Actual - Last Year 年累计实际 - 去年', 'Trainee 实习生'];
                        if (index == 9) {
                            return (
                                <div className={`table-padding ${index == 7 ? 'table-color-footer' : ''}`} style={{ textAlign: "left" }}>
                                    -
                                </div>
                            )
                        }
                        if (index != 7 && index != 8 && index != 9 && isOpenLastFill) {
                            return (
                                <Compared data={{ index, key: 'year_lasty_average_payroll', title, sqlName: "_7_2_1", name: record.name, type: 'number' }}>
                                    <div className="table-padding table-color-number">
                                        <InputNumber
                                            formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                            parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                            precision={2}
                                            className="table_numInput"
                                            defaultValue={text}
                                            onBlur={(e) => {
                                                let value = Number(e.target.value.replace(/,/g, '') || '0');
                                                value = Number(value.toFixed(2));
                                                this.onChange('year_lasty_average_payroll', value, index)
                                            }}

                                        />
                                    </div>
                                </Compared>
                            )
                        } else {
                            return (
                                <Compared data={{ index, key: 'year_lasty_average_payroll', title, sqlName: "_7_2_1", name: record.name, type: 'number' }}>
                                    <div className={`table-padding ${index == 7 ? 'table-color-footer' : ''}`} >
                                        {Number(text) < 0 ? <span style={{ color: "red" }}>({Math.abs(text)})</span> : text.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}{index == 9 ? '%' : ''}
                                    </div>
                                </Compared>
                            )
                        }
                    }
                }, {
                    title: <div>FTE 全体员工</div>,
                    dataIndex: 'year_lasty_payroll_cost',
                    key: 'year_lasty_payroll_cost',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        const title = ['YTD 年累计', 'YTD Actual - Last Year 年累计实际 - 去年', 'FTE 全体员工'];
                        if (index == 9) {
                            return (
                                <div className={`table-padding ${index == 7 ? 'table-color-footer' : ''}`} style={{ textAlign: "left" }}>
                                    -
                                </div>
                            )
                        }
                        return (
                            <Compared data={{ index, key: 'year_lasty_payroll_cost', title, sqlName: "_7_2_1", name: record.name, type: 'number' }}>
                                <div className={`table-padding ${index == 7 ? 'table-color-footer' : ''}`} >
                                    {Number(text) < 0 ? <span style={{ color: "red" }}>({Math.abs(text)})</span> : text.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                </div>
                            </Compared>
                        )
                    }
                }]
            }, {
                align: "center",
                title: 'YTD Variance - This Year vs. Last Year 年累计差异 - 今年对比去年',
                width: 750,
                children: [{
                    title: <div>Full Time 全职</div>,
                    dataIndex: 'year_variance_emplyee_num',
                    key: 'year_variance_emplyee_num',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        const title = ['YTD 年累计', 'YTD Variance - This Year vs. Last Year 年累计差异 - 今年对比去年', 'Full Time 全职'];
                        if (index == 9) return <TableText data={{
                            text, index, type: 'percent', name: "year_variance_emplyee_num", onChange: this.onChange, compared: {
                                title, record, sqlName: "_7_2_1"
                            }
                        }} />;
                        return (
                            <Compared data={{ index, key: 'year_variance_emplyee_num', title, sqlName: "_7_2_1", name: record.name, type: 'number' }}>
                                <div className={`table-padding  ${index == 7 ? 'table-color-footer' : ''}`} >
                                    {Number(text) < 0 ? <span style={{ color: "red" }}>({Math.abs(text)})</span> : text.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                </div>
                            </Compared>
                        )
                    }
                }, {
                    title: '% 百分比',
                    dataIndex: 'year_ven_percent',
                    key: 'year_ven_percent',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        const title = ['YTD 年累计', 'YTD Variance - This Year vs. Last Year 年累计差异 - 今年对比去年', '% 百分比'];
                        return (
                            <Compared data={{ index, key: 'year_ven_percent', title, sqlName: "_7_2_1", name: record.name, type: 'percent' }}>
                                <div className={`table-padding ${index == 7 ? 'table-color-footer' : ''}`} >
                                    {Number(text) < 0 ? <span style={{ color: "red" }}>({(Math.abs(text) * 100).toFixed(1) + '%'})</span> : (text * 100).toFixed(1) + '%'}
                                </div>
                            </Compared>
                        )
                    }
                }, {
                    title: <div>Trainee 实习生</div>,
                    dataIndex: 'year_variance_average_payroll',
                    key: 'year_variance_average_payroll',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        const title = ['YTD 年累计', 'YTD Variance - This Year vs. Last Year 年累计差异 - 今年对比去年', 'Trainee 实习生'];
                        if (index == 9) return <TableText data={{
                            text, index, type: 'percent', name: "year_variance_average_payroll", onChange: this.onChange, compared: {
                                title, record, sqlName: "_7_2_1"
                            }
                        }} />;
                        return (
                            <Compared data={{ index, key: 'year_variance_average_payroll', title, sqlName: "_7_2_1", name: record.name, type: 'number' }}>
                                <div className={`table-padding ${index == 7 ? 'table-color-footer' : ''}`} >
                                    {Number(text) < 0 ? <span style={{ color: "red" }}>({Math.abs(text)})</span> : text.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                </div>
                            </Compared>
                        )
                    }
                }, {
                    title: '% 百分比',
                    dataIndex: 'year_vap_percent',
                    align: "center",
                    key: 'year_vap_percent',
                    width: 150,
                    render: (text, record, index) => {
                        const title = ['YTD 年累计', 'YTD Variance - This Year vs. Last Year 年累计差异 - 今年对比去年', '% 百分比'];
                        if (index == 9) {
                            return (
                                <div className={`table-padding ${index == 7 ? 'table-color-footer' : ''}`} style={{ textAlign: "left" }}>
                                    -
                                </div>
                            )
                        }
                        return (
                            <Compared data={{ index, key: 'year_vap_percent', title, sqlName: "_7_2_1", name: record.name, type: 'percent' }}>
                                <div className={`table-padding ${index == 7 ? 'table-color-footer' : ''}`} >
                                    {Number(text) < 0 ? <span style={{ color: "red" }}>({(Math.abs(text) * 100).toFixed(1) + '%'})</span> : (text * 100).toFixed(1) + '%'}
                                </div>
                            </Compared>
                        )
                    }
                }, {
                    title: <div>FTE 全体员工</div>,
                    dataIndex: 'year_variance_payroll',
                    key: 'year_variance_payroll',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        const title = ['YTD 年累计', 'YTD Variance - This Year vs. Last Year 年累计差异 - 今年对比去年', 'FTE 全体员工'];
                        if (index == 9) return <TableText data={{
                            text, index, type: 'percent', name: "year_variance_payroll", onChange: this.onChange, compared: {
                                title, record, sqlName: "_7_2_1"
                            }
                        }} />;
                        return (
                            <Compared data={{ index, key: 'year_variance_payroll', title, sqlName: "_7_2_1", name: record.name, type: 'number' }}>
                                <div className={`table-padding ${index == 7 ? 'table-color-footer' : ''}`} >
                                    {Number(text) < 0 ? <span style={{ color: "red" }}>({Math.abs(text)})</span> : text.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                </div>
                            </Compared>
                        )
                    }
                }]
            },],
        }];

        return (
            <Spin spinning={this.state.loading}>
                <div className="table7_1_1">
                    <Row className="title" id="table7_2" style={{ width: this.state.print ? 3800 : 'auto' }}>
                        <Row>7.2 Associate Turnover 员工离职率</Row>
                        <Row className="table-month">
                            <MonthPicker
                                placeholder="请选择年月"
                                monthCellContentRender={(date, local) => {
                                    return moment(date).format('M月')
                                }}
                                defaultValue={moment(this.state.date, "YYYY-MM")}
                                format="YYYY-MM"
                                onChange={(date, str) => {
                                    this.setState({
                                        date: str,
                                        data: [],
                                        loading: true,
                                        note: { note: "" }
                                    });
                                    this.getDateData(str)
                                }}
                            />
                        </Row>
                        <Table
                            columns={columns}
                            dataSource={data}
                            size="middle"
                            bordered
                            pagination={false}
                            className="content"
                            style={{ width: this.state.print ? 3750 : 'auto' }}
                            scroll={this.state.print ? {} : { x: 3750 }}
                            rowKey={(record, index) => index}
                        />
                        <Row style={{ margin: "20px 0", }}>
                            <Row style={{ margin: "10px 0" }}>7.2.1 Comments备注: </Row>
                            {this.state.data.length > 0 ? <TextArea
                                rows={4}
                                placeholder="请输入备注！"
                                defaultValue={this.state.note.note}
                                onBlur={(e) => {
                                    this.setState({
                                        note: { ...this.state.note, note: e.target.value }
                                    });
                                }}
                            /> : null}
                        </Row>
                    </Row>
                    <Auth loading={this.state.loading} auth="edit_7_2">
                        <Row className="table-footer-btn">
                            <Button
                                type="primary"
                                style={{ marginRight: 10 }}
                                onClick={this.downloadSG}
                                loading={this.state.print}
                            >加入pdf</Button>
                            <Button
                                type="primary"
                                onClick={this.onSave}
                                loading={this.state.loadingSave}
                            >保存</Button>
                        </Row>
                    </Auth>

                </div>
                <Chart></Chart>
            </Spin >
        );
    }
}

export default index;


// WEBPACK FOOTER //
// ./src/components/table/7-HumanResourcesAnalysis/7-2/index.js